// Copyright (c) 2025 WiseTime. All rights reserved.

import { Action } from "redux"
import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slice"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { userTeamClient } from "../../../app/rpc/client"
import { GetTeamRequest, GetTeamResponse } from "../../../generated/wt/svc/customer/user_team_pb"

type GetTeamRpc = (siteId: Slice.SiteId) => Observable<GetTeamResponse>

export const getTeam = (getTeamRpc: GetTeamRpc) => (action$: Observable<Action>): Observable<Action> =>
  action$.pipe(
    filter(Slice.setCurrentSiteId.match),
    mergeMap(({ payload: { siteId }}) =>
      of(siteId)
        .pipe(
          mergeMap(getTeamRpc),
          map(r => r.toObject()?.team),
          map(Slice.setTeamProto),
          catchError(_ => of(Actions.getTeamFailed()))
        )
    )
  )

const getTeamRpc = (siteId: Slice.SiteId): Observable<GetTeamResponse> =>
  grpc(() => userTeamClient.getTeam(new GetTeamRequest().setTeamId(siteId), null))

export default getTeam(getTeamRpc)
